(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var _lastFetchedProductId = null;

    function fetchUpsellRecommendations(upsellEl, productId) {
      if (!productId) return;

      var limit = parseInt(upsellEl.dataset.upsellLimit || '4', 10);
      var track = upsellEl.querySelector('[data-upsell-track]');
      if (!track) return;

      // Skip only if we already have real cards for this product. After the drawer
      // re-renders the track is reset to skeletons, so we must re-fetch even for the
      // same product id.
      if (productId === _lastFetchedProductId && track.querySelector('.cu-card')) return;

      _lastFetchedProductId = productId;

      fetch(
        '/recommendations/products?section_id=cart-upsell-recommendations' +
        '&product_id=' + productId +
        '&limit=' + limit +
        '&intent=related'
      )
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('.cu-card');
          track.innerHTML = '';
          if (cards.length === 0) {
            upsellEl.style.display = 'none';
            return;
          }
          cards.forEach(function (card) { track.appendChild(card); });
        })
        .catch(function () {
          upsellEl.style.display = 'none';
          _lastFetchedProductId = null;
        });
    }

    function tryInitUpsell() {
      var upsellEl = document.querySelector('.cart-upsell[data-upsell-source="recommendations"]');
      if (!upsellEl) return;

      var productId = upsellEl.dataset.upsellProductId;

      if (productId) {
        fetchUpsellRecommendations(upsellEl, productId);
      } else {
        fetch('/cart.json')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.items && cart.items.length > 0) {
              var pid = String(cart.items[0].product_id);
              upsellEl.dataset.upsellProductId = pid;
              fetchUpsellRecommendations(upsellEl, pid);
            } else {
              upsellEl.style.display = 'none';
            }
          })
          .catch(function () { upsellEl.style.display = 'none'; });
      }
    }

    function bindDrawerOpenListener() {
      var drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl) {
        drawerEl.addEventListener('dialog:open', tryInitUpsell);
      }
    }

    // True when the recommendations upsell is showing skeletons but has no real cards yet.
    function upsellNeedsFetch() {
      var upsellEl = document.querySelector('.cart-upsell[data-upsell-source="recommendations"]');
      if (!upsellEl) return false;
      var track = upsellEl.querySelector('[data-upsell-track]');
      return !!(track && !track.querySelector('.cu-card') && track.querySelector('.cart-upsell__skeleton'));
    }

    var _initTimer = null;
    function scheduleInit() {
      clearTimeout(_initTimer);
      _initTimer = setTimeout(tryInitUpsell, 60);
    }

    // Safety net: whenever the drawer re-renders and the upsell reappears as skeletons
    // (add/remove item, re-open, or a slow first load), re-run the fetch. Fetching only
    // happens when real cards are absent, so this can't loop.
    function startObserving() {
      var root = document.querySelector('cart-drawer-component');
      if (!root) return;
      var observer = new MutationObserver(function () {
        if (upsellNeedsFetch()) scheduleInit();
      });
      observer.observe(root, { childList: true, subtree: true });
      if (upsellNeedsFetch()) scheduleInit();
    }

    function init() {
      bindDrawerOpenListener();
      startObserving();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function revealNextReserve(track) {
      var reserve = track.querySelector('.cu-card--reserve');
      if (reserve) {
        reserve.classList.remove('cu-card--reserve');
        reserve.removeAttribute('aria-hidden');
        reserve.style.opacity = '0';
        requestAnimationFrame(function () {
          reserve.style.transition = 'opacity 0.3s';
          reserve.style.opacity = '1';
        });
      }
    }

    function removeCardFromCarousel(productId) {
      var track = document.querySelector('.cart-upsell__track[data-upsell-track]');
      if (!track) return;
      var card = track.querySelector('.cu-card:not(.cu-card--reserve)[data-product-id="' + productId + '"]');
      if (!card) return;
      var w = card.offsetWidth;
      card.style.transition = 'opacity 0.2s';
      card.style.opacity = '0';

      setTimeout(function () {
        card.style.transition = 'max-width 0.25s, margin 0.25s';
        card.style.maxWidth = w + 'px';
        card.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          card.style.maxWidth = '0';
          card.style.marginRight = '0';
        });
        setTimeout(function () {
          card.remove();
          var upsellEl = document.querySelector('.cart-upsell[data-upsell-source="collection"]');
          if (upsellEl) revealNextReserve(track);
        }, 280);
      }, 220);
    }

    document.addEventListener('cart:update', function (e) {
      var productId = e.detail && e.detail.data && e.detail.data.productId;
      if (productId) {
        removeCardFromCarousel(String(productId));
        _lastFetchedProductId = null;
        var upsellEl = document.querySelector('.cart-upsell[data-upsell-source="recommendations"]');
        if (upsellEl) {
          upsellEl.dataset.upsellProductId = '';
          tryInitUpsell();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
